import * as React from 'react';
import { SVGProps } from 'react';

const IconLinkSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.244 6.5H3.74v-1h4.503v1Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.002 4a2 2 0 1 0 0 4h1.993v1H3.002a3.001 3.001 0 1 1 0-6h1.993v1H3.002ZM9.006 8c1.105 0 1.993-.9 1.993-2.004A1.99 1.99 0 0 0 9.006 4H7.012V3h1.994A2.99 2.99 0 0 1 12 5.996 2.998 2.998 0 0 1 9.006 9H7.012V8h1.994Z"
    />
  </svg>
);
export default IconLinkSizeXs;
